(function () {
  var sectionSelector = [
    '.dev-hero',
    '.dev-slider-section',
    '.dev-product-collection',
    '.dev-product-view',
    '.dev-poster',
    '.dev-poster-2',
    '.dev-poster-3',
    '.dev-poster-4',
    '.dev-poster-5',
    '.dev-newslatter'
  ].join(',');

  var animationMap = [
    { selector: '.dev-hero__overlay-left, .dev-product-view__caption--left, .dev-poster__left, .dev-poster-2__left-text, .dev-poster-3__images--left, .dev-poster-5__image--left, .dev-poster-5__stage-mob-two-image--left', type: 'from-left' },
    { selector: '.dev-hero__overlay-right, .dev-product-view__caption--right, .dev-poster__right, .dev-poster-2__right-text, .dev-poster-3__images--right, .dev-poster-5__image--right, .dev-poster-5__stage-mob-two-image--right', type: 'from-right' },
    { selector: '.dev-hero__video-wrap, .dev-product-view video, .dev-product-view__placeholder, .dev-poster-2__main-image, .dev-poster-3__images--center, .dev-poster-4__media, .dev-poster-5__image--center', type: 'scale' },
    { selector: '.dev-slider__top-richtext, .dev-slider__stage, .dev-slider__bottom, .dev-product-collection__heading, .dev-product-collection__details, .dev-poster__content, .dev-poster-3__heading, .dev-poster-3__description, .dev-poster-4__heading, .dev-poster-4__body, .dev-poster-5__text, .dev-poster-5__stage-mob-top, .dev-poster-5__stage-mob-center-text, .dev-newslatter__text, .dev-newslatter__button', type: 'rise-soft' },
    { selector: '.dev-product-collection__card, .dev-slider__slide-media, .dev-slider__overlay-title, .dev-slider__controls, .dev-poster-2__accent-center, .dev-poster-5__stage-mob-two-images', type: 'fade' }
  ];

  var textSelector = [
    '.dev-hero__overlay-left',
    '.dev-hero__overlay-right',
    '.dev-slider__top-richtext',
    '.dev-slider__overlay-title',
    '.dev-slider__control-label',
    '.dev-slider__bottom-item',
    '.dev-product-collection__heading',
    '.dev-product-collection__cta',
    '.dev-product-collection__details-title',
    '.dev-product-collection__details-description',
    '.dev-product-collection__details-label',
    '.dev-product-view__caption',
    '.dev-poster__heading',
    '.dev-poster-2__left-text',
    '.dev-poster-2__right-text',
    '.dev-poster-3__heading',
    '.dev-poster-3__description',
    '.dev-poster-4__heading',
    '.dev-poster-4__body',
    '.dev-poster-5__text',
    '.dev-poster-5__stage-mob-top',
    '.dev-poster-5__stage-mob-main',
    '.dev-poster-5__stage-mob-bottom',
    '.dev-newslatter__text',
    '.dev-newslatter__button'
  ].join(',');

  function markAnimated(section) {
    if (!section || section.dataset.devAnimationReady === 'true') return;

    section.dataset.devAnimationReady = 'true';
    var index = 0;

    animationMap.forEach(function (entry) {
      section.querySelectorAll(entry.selector).forEach(function (element) {
        if (element.hasAttribute('data-dev-animate')) return;

        element.setAttribute('data-dev-animate', entry.type);
        element.style.setProperty('--dev-anim-delay', Math.min(index * 90, 540) + 'ms');
        index += 1;
      });
    });

    section.querySelectorAll(textSelector).forEach(function (element, textIndex) {
      element.classList.add('dev-text-animate');

      if (!element.hasAttribute('data-dev-animate')) {
        element.setAttribute('data-dev-animate', 'rise-soft');
        element.style.setProperty('--dev-anim-delay', Math.min(textIndex * 80, 560) + 'ms');
      }
    });
  }

  function reveal(section) {
    markAnimated(section);
    section.classList.add('dev-animation-visible');
  }

  function hide(section) {
    markAnimated(section);
    section.classList.remove('dev-animation-visible');
  }

  function initAnimations(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches(sectionSelector)) {
      sections.push(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach(function (section) {
      sections.push(section);
    });

    if (!sections.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          return;
        }

        hide(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.14
    });

    sections.forEach(function (section) {
      markAnimated(section);
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAnimations(document);
    });
  } else {
    initAnimations(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAnimations(event.target);
  });
})();
